export default "__VITE_ASSET__Dn1U2gx8__"